import { AutoComplete, Button, Form, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../Common/CommonInput";
import {
  dispatchtoast,
  getLocalStorageItem,
  mobilePattern,
} from "../../../Utils";
import { getUPIPayments } from "../../../ApiServices/Apifun";
import ReportDrawer from "../../../Common/ReportDrawer";
import Content from "../../../Common/ReceiptContent";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { useNavigate } from "react-router-dom";

const UPIpayments = () => {
  const [details, setDetails] = useState([]);
  const [purpose, setPurpose] = useState("");
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [btnLoading, setBtnLoading] = useState(false);
  // const [needToVerify,setNeedtoVerify]=useState(true)
  const formref = useRef();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  let debounceTimer;
  useEffect(() => {
    dispatch(setselectedTab("4"));
    if (!memberServices.includes("122")) {
      navigate("/not-Available");
    }
  }, []);

  const handlePay = (val) => {
    const formdata = new FormData();
    const data = { ...val };
    data.bank_id = data.bank_id?.value ? data.bank_id?.value : data?.bank_id;
    formdata.append("benificiary_account", data.benificiary_account);
    formdata.append("benificiary_name", data.benificiary_name);
    formdata.append("amount", data.amount);
    formdata.append("payment_purpose", purpose);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    setBtnLoading(true);
    getUPIPayments(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message, 3);
          form.resetFields();
          //   setAllData({ ...val, otp_uid: res.otp_uid });
          //   setOpenOtpModal(true);
        } else {
          dispatchtoast(res.message, true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> UPI Payments</p>
          <Form
            name="basic"
            initialValues={{
              remember: true,
            }}
            ref={formref}
            form={form}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handlePay(val)}
          >
            <Form.Item
              name={`benificiary_account`}
              label={"UPI ID"}
              labelCol={{ span: 24 }}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: "Enter Account Number!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <AutoComplete
                className="w-full"
                value={""}
                // onSearch={(e) => getBeneFiciarySearch(e)}
                placeholder="Enter Upi'id "
                options={details}
              />
            </Form.Item>
            <Spin spinning={spinner}>
              <Form.Item
                name={`amount`}
                label={"Amount"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Amount!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    e.target.value = value;
                  }}
                  placeholder="Enter Amount"
                  name="amount"
                />
              </Form.Item>
              <Form.Item
                name={`benificiary_name`}
                label={"Benificiary Name"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Benificiary Name!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter Benificiary Name"
                  name="benificiary_name"
                />
              </Form.Item>{" "}
              <Form.Item
                name={`purpose`}
                label={"Payment Purpose"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select Purpose!",
                  },
                ]}
              >
                <select
                  className="w-full border border-gray-300 rounded-lg  text-sm"
                  value={purpose}
                  onChange={(e) => setPurpose(e.target.value)}
                >
                  <option value="">----Select Purpose of Payment----</option>
                  <option value="Education Fees">Education Fees</option>
                  <option value="Rent">Rent</option>
                  <option value="Commission">Commission</option>
                  <option value="Salary">Salary</option>
                  <option value="Hospital">Hospital</option>
                  <option value="Vendor Payment">Vendor Payment</option>
                </select>
              </Form.Item>{" "}
              {/* )} */}
            </Spin>
            <Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Pay
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      {openReceiptDrawer && (
        <ReportDrawer
          title={" Express DMT Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={result} />}
        />
      )}
    </>
  );
};

export default UPIpayments;
